import { isLocalParticipantModerator, isParticipantModerator } from "../base/participants/functions";
const getState = (state) => state['features/vt-chat-moderation'];
export const isEnableBanAll = (state) => getState(state)?.enabled ?? false;
export const getRecentSenders = (state) => getState(state)?.recentSenders ?? {};
export const getSenderByUserId = (userId, state) => getState(state)?.recentSenders[userId] ?? null;
export const isLocalParticipantCanChat = (state) => {
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    const { canChat } = getState(state);
    if (canChat !== undefined) {
        return canChat;
    }
    return !isEnableBanAll(state);
};
export const isParticipantApprovedChat = (participantId, state) => getState(state)?.whitelist[participantId] ?? false;
export const isParticipantRejectedChat = (participantId, state) => getState(state)?.blacklist[participantId] ?? false;
export function isBannedChat(participant, state) {
    if (participant.local) {
        return !isLocalParticipantCanChat(state);
    }
    // moderators cannot be mute chat
    if (isParticipantModerator(participant)) {
        return false;
    }
    if (isEnableBanAll(state)) {
        return !isParticipantApprovedChat(participant.id, state);
    }
    return Boolean(isParticipantRejectedChat(participant.id, state));
}
